import PropTypes from "prop-types"

import StatCard from "../stat_card"
import SimpleLineChart from "../simple_line_chart"
import LineComparisonChart from "../charts/line_comparison_chart"
import userMetricsFetcher from "./user_metrics_fetcher"
import PeriodSelectionHOC from "../period_selection_hoc"
import { parseStat, parseChange, TimePeriods } from "../lib"
import "../stats.scss"

const UsersComponent = ({
  data,
  timePeriodInDays,
  timePeriod,
  serviceName,
}) => (
  <>
    <div styleName="stats-container engagement">
      <div styleName="stats-box tall">
        <StatCard
          statText={"New connected users"}
          stat={parseStat(data, "current", timePeriod, "new_users")}
          changeRate={parseChange(data, timePeriod, "new_users")}
          className="bigger"
          compactStat={false}
          timePeriodInDays={timePeriodInDays}
        />
        <StatCard
          statText={"Average daily connections"}
          stat={Math.ceil(
            parseStat(data, "current", timePeriod, "new_users") /
              timePeriodInDays
          )}
          subText={"Average number of users connecting to your service daily"}
          statUnitText={`Times per day`}
          className="bigger"
          compactStat={false}
          timePeriodInDays={timePeriodInDays}
          tooltipText={`Number of new users who have connected to ${serviceName} ${TimePeriods[timePeriod].description}`}
          lowThreshold={0.5}
          lowValue={"<1"}
        />
      </div>
      <div styleName="chart">
        <LineComparisonChart
          data={data.daily}
          metric={"new_users_daily"}
          height={350}
          timePeriodInDays={timePeriodInDays}
          units={"users"}
          lineOnly
        />
      </div>
      <div className="chart-legend horizontal">
        <div>
          <div
            className="line-color"
            style={{
              backgroundColor: LineComparisonChart.defaultProps.lineColorA,
            }}
          />
          Last {timePeriodInDays} days
        </div>
        <div>
          <div
            className="line-color"
            style={{
              backgroundColor: LineComparisonChart.defaultProps.lineColorB,
            }}
          />
          Prior {timePeriodInDays} days
        </div>
      </div>
    </div>
    <div styleName="grouped-charts">
      <SimpleLineChart
        chartTitle={"New users with enabled Applets"}
        data={data.daily}
        currentValue={parseStat(data, "current", timePeriod, "active_users")}
        changeRate={parseChange(data, timePeriod, "active_users")}
        metric={"active_users_daily"}
        units={"users"}
        timePeriodInDays={timePeriodInDays}
        tooltipText={`Number of connected users who have enabled an Applet using ${serviceName} ${TimePeriods[timePeriod].description}`}
      />
      <SimpleLineChart
        chartTitle={`Users with an Applet run`}
        data={data.daily}
        currentValue={parseStat(
          data,
          "current",
          timePeriod,
          "users_with_an_applet_run"
        )}
        changeRate={parseChange(data, timePeriod, "users_with_an_applet_run")}
        metric={"users_with_an_applet_run_daily"}
        units={"users"}
        timePeriodInDays={timePeriodInDays}
        tooltipText={`Number of ${serviceName} users who had a ${serviceName} Applet run ${TimePeriods[timePeriod].description}`}
      />
    </div>
  </>
)

UsersComponent.propTypes = {
  data: PropTypes.shape({
    daily: PropTypes.arrayOf(PropTypes.object),
    current: PropTypes.arrayOf(PropTypes.object),
    comparison: PropTypes.arrayOf(PropTypes.object),
  }),
  newConnectedUsers: PropTypes.number,
  newConnectedUsersChange: PropTypes.number,
  activeUsers: PropTypes.number,
  activeUsersChange: PropTypes.number,
  usersWithAnAppletRun: PropTypes.number,
  usersWithAnAppletRunChange: PropTypes.number,
  serviceName: PropTypes.string,
}

export default PeriodSelectionHOC({
  WrappedComponent: UsersComponent,
  serviceMetricsFetcher: userMetricsFetcher,
  headerText: "Users",
  subHeaderText: "User adoption metrics for %SERVICE_NAME% per time period",
})
